import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { USER_INFO } from '../../models/profile-selector.interface';
import { SwitchingAccountBaseService } from './switching-account-base.service';
@Injectable({
  providedIn: 'root'
})
export class SwitchingAccountExtendedService extends SwitchingAccountBaseService {
  isValidResponse(
    types: string[],
    contractMgtEnt: string[],
    program: string[]
  ): boolean {
    return !!types.length && !!contractMgtEnt.length && !!program.length;
  }

  extractValuesFromResponse(): {
    types: string[];
    contractMgtEnt: string[];
    program: string[];
    id: string[];
  } {
    const { crprtAgrmntTypeCode, contractMgtEnt, program, crprtAgrmntId } =
      this.dashboardResponse;

    return {
      types: crprtAgrmntTypeCode.split('|'),
      contractMgtEnt: contractMgtEnt.split('|'),
      program: program.split('|'),
      id: crprtAgrmntId.split('|')
    };
  }

  getValuesAtIndex(
    types: string[],
    contractMgtEnt: string[],
    program: string[],
    id: string[],
    resData: string
  ): [string, string, string, string] {
    const index = parseInt(resData.split(':')[1], 10);
    return [types[index], contractMgtEnt[index], program[index], id[index]];
  }

  updateCorporateName(corporateName: string): void {
    this.accountName = corporateName;
    this.displayCorporateName = corporateName;
  }

  getCorpNameFromCookies(): string {
    const cookies = this.cookieHelper.getCookies('corp');
    return cookies
      ? cookies.split('|')[1].split('=')[1].replace(/#/g, ' ')
      : '';
  }

  setCorporateName(corpName: string): void {
    this.displayCorporateName = corpName;
  }

  toggleAccountHelper(): void {
    this.userSession
      .getUserSession()
      .pipe(take(1))
      .subscribe((res) => {
        if (res && res.crprtAgrmntTypeCode) {
          this.businessAccount = true;
        } else {
          this.businessAccount = false;
        }
      });
  }

  getOtherAccountDetailsFromCookie(corpCookie: string): void {
    let tempPartnerId = '';
    const account = this.cookieHelper.getAccountCookie('account');
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    const parseAccount = this.parseAndValidateAccount(account);

    tempPartnerId = parseAccount?.partnerId
      ? parseAccount.partnerId
      : setPartnerToPersonal?.length
      ? setPartnerToPersonal
      : corpCookie
      ? 'edp'
      : '';

    this.partnerId = this.getHipmunkCookie(tempPartnerId);
  }

  getHipmunkCookie(tempPartnerId: string): string {
    return this.cookieHelper.getCookieValue('isHipmunk')
      ? 'hipmunk'
      : tempPartnerId;
  }

  parseAndValidateAccount(
    account: string | null
  ): { isOaSmeAccount: boolean; partnerId: string } | null {
    if (!account || !account.length) {
      return null;
    }

    const parsedAccount = JSON.parse(account);
    this.businessAccountOptionsLists = parsedAccount.businessAccountOptionsList;
    this.oaSmeAccount = parsedAccount.businessAccountOptionsList.isOaSmeAccount;
    return {
      isOaSmeAccount: parsedAccount.businessAccountOptionsList.isOaSmeAccount,
      partnerId: parsedAccount.businessAccountOptionsList.partnerId
    };
  }

  getUserInfo(): USER_INFO {
    const info = {
      isBusinessAccount: this.businessAccount,
      businessAccountOptionsLists: this.businessAccountOptionsLists,
      isOaSmeAccount: this.oaSmeAccount,
      isBusinessUser: this.businessUser,
      isIntranetLink: this.intranetLink,
      selectedCompany: this.displayCorporateName
        ? this.displayCorporateName
        : this.accountName,
      pageName: 'home',
      channelId: 'ecomm'
    };
    return info;
  }

  initializeViewData(): {
    isOaSmeAccount: boolean;
  } {
    return { isOaSmeAccount: false };
  }

  setBusinessUser(flag: boolean): void {
    this.businessUser = flag;
  }

  getDisplayStatus(): boolean {
    return this.display;
  }

  setIntranetlink(val: boolean): void {
    this.intranetLink = val;
  }
}
